import { Box, Stack, Typography } from '@mui/material'

import { BAR_ALPHA } from '../chartConfig'

interface Props {
  label: string
  swatch: 'line' | 'bar'
  color: string
}

export const LegendItem = ({ label, swatch, color }: Props) => (
  <Stack direction='row' spacing={0.5} alignItems='center'>
    <Box
      sx={
        swatch === 'line'
          ? { width: 18, height: 2, bgcolor: color, borderRadius: 1 }
          : { width: 12, height: 12, bgcolor: color, opacity: BAR_ALPHA, borderRadius: 0.5 }
      }
    />
    <Typography variant='caption' color='text.secondary'>
      {label}
    </Typography>
  </Stack>
)
